// i18n area 'networks' — locale fr-FR (task #171, onda 1): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/networks.fr-FR.meta.json.
import type { enUS } from './networks'

export const frFR: typeof enUS = {
  networks: {
    common: {
      name: 'Nom',
      scope: 'Scope',
      operState: 'État',
      actions: 'Actions',
      create: 'Créer',
      close: 'Fermer',
      cancel: 'Annuler',
      delete: 'Supprimer',
      edit: 'Modifier',
      save: 'Enregistrer',
      editError: 'Modification échouée',
      search: 'Rechercher par nom',
      empty: 'Encore rien ici',
      saveError: "Impossible d'enregistrer",
      loadError: 'Impossible de charger — le backend TVirt est-il joignable ?',
      createError: 'Création échouée',
      deleteError: 'Suppression échouée',
      deleteConfirmTitle: 'Supprimer {name} ?',
      deleteConfirmBody: "L'opération n'est pas réversible.",
      nameHint: 'Minuscules, chiffres et tirets (DNS-1123)',
      up: 'Actif',
      down: 'Inactif',
      unknown: 'Inconnu',
      usedByVMs: 'VM',
      emptyTable: 'Aucune entrée — ajoutez-en une avec le bouton +'
    },
    dialogTabs: {
      general: 'Général',
      base: 'Définition de base',
      advanced: 'Configuration avancée',
      reserved: 'Ranges réservés à TVirt',
      position: 'Position',
      network: 'Configuration réseau',
      hosts: 'Nœuds participants'
    },
    reservedRanges: {
      note: "Ce sont les ranges d'IP réservés à TVirt qu'il peut utiliser pour assigner automatiquement une adresse aux VM, containers, etc. NOTE : les IP dans ces ranges ne doivent pas être utilisées en dehors de TVirt par des services ou appliances externes.",
      from: 'De',
      to: 'À'
    },
    overlay: {
      title: 'Réseaux overlay',
      createTitle: 'Créer un réseau overlay',
      editTitle: 'Modifier le réseau overlay',
      vni: 'VNI',
      vniHint: 'VXLAN Network Identifier — assigné automatiquement si vide',
      subnet: 'Subnet',
      subnetHint: "Le CIDR de l'overlay — l'IPAM en dérive automatiquement l'entrée de registre",
      mtu: 'MTU',
      weight: 'Poids',
      ceilMbps: 'Plafond (Mbps)',
      fairnessHint: "Le poids ne compte que sous contention : sur un lien inactif, chaque réseau peut utiliser toute la bande passante. Le plafond, lui, s'applique toujours.",
      contention: 'Contention',
      contentionTip: 'Au moins un nœud observe des pertes ou des overlimits AVEC une file sur la classe de ce réseau : la bande passante de l\'uplink est disputée et les poids agissent. Combien et depuis quand se lisent dans les séries net.shaping.* du nœud.',
      firewallPolicy: 'Politique firewall',
      hosts: 'Hosts',
      hostsTitle: 'Nœuds participants',
      hostsHint: "Chaque nœud déclare son endpoint underlay — un select sur les adresses RÉELLES du nœud, lues depuis sa configuration réseau ; l'adresse overlay optionnelle doit rester dans le subnet. La participation est la contrainte de placement.",
      hostNode: 'Nœud',
      hostUnderlay: 'IP underlay',
      hostUnderlayPickNode: "Choisissez d'abord le nœud",
      hostAddress: "Adresse sur l'overlay (optionnelle)",
      hostAddressOutside: 'Hors du sous-réseau de l\'overlay ({cidr})',
      addHost: 'Ajouter un nœud',
      observedAt: 'Observé le',
      attachedNics: 'NIC attachées'
    },
    services: {
      title: 'Services réseau',
      createTitle: 'Créer un service réseau',
      editTitle: 'Modifier le service réseau',
      kind: 'Type',
      kindCategory: 'Services',
      selectKindHint: "Choisissez le type de service — le démon sous-jacent est un détail d'implémentation que TVirt gère pour vous.",
      kindLabel: {
        dhcp: 'Serveur DHCP',
        ntp: 'Serveur NTP',
        vpn: 'Serveur VPN',
        dns: 'Serveur DNS',
        gateway: 'Gateway',
        'lb-rp': 'Load balancer et reverse proxy',
        floatip: 'IP flottante'
      },
      kindDesc: {
        dhcp: 'Assigne des adresses sur les subnets servis — les pools dérivent du subnet, du gateway et des ranges réservés à TVirt du réseau.',
        dns: "DNS autoritatif sur les zones déclarées — les records dérivent de l'IPAM plus vos manuels.",
        gateway: 'Le nœud fait office de gateway pour un réseau — NAT (DNAT, 1:1, SNAT/masquerade) plus routage statique entre les réseaux attachés, auto-réparant par design.',
        'lb-rp': 'Répartiteur de charge / proxy inverse devant vos services — listeners L4 ou L7 sur des pools de membres ou sur les instances prêtes d\'un Pod, reconfigurés à chaud.',
        ntp: "Le service horaire des réseaux — relay de serveurs upstream externes, ou l'horloge du nœud servie aux clients.",
        vpn: "Un concentrateur VPN sur le nœud — WireGuard ou OpenVPN, à vous de choisir : accès distant pour les clients itinérants, ou un tunnel site to site entre deux réseaux.",
        floatip: 'Une adresse qui réside sur UNE seule instance App ou Pod saine à la fois et se déplace vers la prochaine cible saine quand celle-ci tombe — failover sans démon ; la répartition reste au répartiteur de charge.'
      },

      // Round Pod nativi P4: l'IP flottante (4b) e il backend Pod dell'lb-rp (4a).
      floatip: {
        hint: 'L\'IP flottante vit sur le réseau choisi comme adresse SUPPLÉMENTAIRE dans l\'espace de noms de l\'instance détentrice : pas de ports, pas de répartition, pas de NAT — l\'IP du client reste vraie.',
        address: 'IP flottante',
        targets: 'Cibles',
        targetsHint: 'Par ordre de PRÉFÉRENCE : la première cible saine détient l\'adresse. Un Pod vaut pour toutes ses instances, par réplique ; chaque cible a son propre critère de santé. Chaque cible doit être rattachée au même réseau.',
        targetKind: 'Cible',
        targetApp: 'Instance App',
        targetPod: 'Pod (toutes les instances)',
        targetRef: 'Laquelle',
        health: 'Santé',
        healthRunning: 'En cours (chaque conteneur prêt)',
        healthTcp: 'Connexion TCP',
        healthHttp: 'HTTP GET',
        healthPing: 'Ping',
        port: 'Port',
        path: 'Chemin',
        addTarget: 'Ajouter une cible',
        moveUp: 'Monter',
        moveDown: 'Descendre',
        preempt: 'Preempt',
        preemptHint: 'Désactivé (défaut) : un détenteur sain garde l\'adresse même si une cible plus haute revient — pas de flapping. Activé : la première cible saine la détient toujours.',
        holder: 'Détenteur',
        noHolder: 'aucune cible saine',
        since: 'depuis',
        verdicts: 'Cibles observées',
        healthy: 'saine',
        unhealthy: 'non saine',
        noVerdict: 'Pas encore décidé — le nœud d\'autorité écrit le premier verdict à sa prochaine passe.',
        vipChip: 'VIP {address}',
        vipChipTooltip: 'Cette instance détient l\'IP flottante {address} du service {service}'
      },
      poolSource: 'Endpoints',
      poolSourceMembers: 'Membres statiques',
      poolSourcePod: 'Les instances prêtes d\'un Pod',
      poolBackendPod: 'Pod',
      poolBackendPort: 'Port',
      poolBackendHint: 'Les endpoints suivent le Pod : une instance entre quand elle tourne avec chaque conteneur prêt, sort aussitôt quand elle est réduite ou meurt. Le contrôle actif est activé par défaut.',
      poolBackendCount: 'les instances prêtes du Pod {pod} sur le port {port}',
      node: 'Nœud',
      enabled: 'Activé',
      parked: 'Parqué',
      subnets: 'Subnets',
      subnetsHint: 'Les subnets IPAM servis par cette instance — les pools dérivent du CIDR, du gateway et des ranges réservés à TVirt',
      noSubnets: "Aucun subnet IPAM — déclarez d'abord un réseau logique de fabric (ou un subnet overlay) : l'IPAM dérive d'eux",
      iface: 'Interface d\'écoute',
      ifaceHint: 'L\'interface hôte sur laquelle le service ouvre son socket (p. ex. un pont) — obligatoire : un service réseau est autonome, « toutes les interfaces » n\'existe plus',
      dns: 'Serveurs DNS',
      domain: 'Domaine',
      detail: 'Sert',
      subnetCount: '{n} subnets',
      zones: 'Zones',
      zonesHint: "Autoritatif seulement — le démon ne fait jamais de récursion. Les records A dérivent des adresses déclarées des nœuds dans les subnets IPAM référencés ; le switch reverse sert aussi les zones in-addr.arpa correspondantes (PTR). Une zone est servie par au plus une instance DNS dans la flotte. Le nameserver optionnel est le FQDN écrit dans les records NS/SOA à la place du défaut ns.<zone> ; s'il tombe dans la zone, son record A dérive quand même du nœud servant.",
      zoneName: 'Nom de la zone',
      zoneNs: 'Nameserver (NS)',
      zoneSubnets: 'Subnets IPAM',
      zoneReverse: 'Reverse (PTR)',
      zoneRecords: 'Records manuels',
      zoneRecordsHint: 'Un par ligne : nom TYPE valeur — types A, CNAME, MX, TXT. En cas de collision sur le nom, le record manuel gagne sur le dérivé.',
      addZone: 'Ajouter une zone',
      lbListeningHint: 'L\'instance déclare UN réseau d\'écoute et UNE adresse — chaque écouteur la lie sur son propre port ; une seconde adresse est un second service.',
      listeners: 'Listeners',
      listenersHint: 'Chaque écouteur lie l\'adresse de l\'instance sur son propre port en mode L4 (passthrough TCP — les octets ne sont jamais ouverts) ou L7 (HTTP) et transmet à l\'un des pools ci-dessous. Un couple adresse/port est servi par au plus une instance par nœud. Les changements s\'appliquent à la volée — pas de redémarrage, pas de connexions perdues.',
      listenerName: 'Nom',
      listenerMode: 'Mode',
      modeL7: 'L7 — reverse proxy HTTP',
      modeL4: 'L4 — passthrough TCP',
      listenerPort: 'Port',
      listenerPool: 'Pool',
      addListener: 'Ajouter un listener',
      pools: 'Pools',
      poolsHint: 'Les backends où atterrit le trafic : membres statiques équilibrés en round-robin ou par le moins occupé, avec un health check actif optionnel qui sort de la rotation les membres malades.',
      poolName: 'Nom',
      poolAlgorithm: 'Algorithme',
      algoRoundRobin: 'Round robin',
      algoLeastRequest: 'Le moins occupé',
      poolCheck: 'Health check',
      checkNone: 'Aucun',
      checkTcp: 'Connexion TCP',
      checkHttp: 'HTTP',
      poolCheckPath: 'Chemin de la sonde',
      poolInterval: 'Intervalle (s)',
      poolMembers: 'Membres',
      poolMembersHint: "Un par ligne : adresse:port, optionnellement suivi d'un poids (1-128) — ex. 10.0.0.21:8080 2",
      addPool: 'Ajouter un pool',
      memberCount: '{n} membres',
      listen: {
        assignment: 'Attribution',
        assignmentStatic: 'Adresse statique',
        assignmentAuto: 'Automatique (plages réservées TVirt)',
        autoHint: 'TVirt extrait l\'adresse des plages réservées du réseau logique et la garde sticky — jamais retirée à un edit ou un failover.',
        title: 'Écouteurs',
        hint: 'Un service réseau est autonome : chaque écouteur déclare son réseau (overlay, réseau logique de fabric ou interface brute) et une adresse dans son sous-réseau — un écouteur par adresse, le wildcard n\'existe plus. DNS et NTP peuvent écouter sur plusieurs réseaux et plusieurs adresses de ces réseaux.',
        address: 'Adresse d\'écoute',
        add: 'Ajouter un écouteur'
      },
      ntp: {
        mode: 'Mode de synchronisation',
        modeRelay: 'Relay de serveurs externes',
        modeNodeClock: 'Horloge du nœud',
        modeHint: "Le relay sert l'heure prise des serveurs upstream déclarés ; l'horloge du nœud sert l'heure du nœud qui l'héberge — que le cluster garde de toute façon synchronisée",
        servers: 'Serveurs upstream',
        serversHint: "Séparés par des virgules — hostname ou adresse IP ; le service prend l'heure ici et la sert au réseau",
        port: "Port d'écoute",
        listening: "À l'écoute sur"
      },
      vpn: {
        engine: 'Moteur',
        engineHint: "C'est vous qui le choisissez, et il ne change plus : WireGuard est moderne, rapide et dans le noyau ; OpenVPN est le vétéran de la compatibilité (TCP, réseaux hostiles)",
        engineLocked: 'Le moteur est immuable — un autre moteur est un nouveau service, ses clés et certificats ne sont pas portables',
        mode: 'Mode',
        modeRemote: 'Accès distant',
        modeSite: 'Site to site',
        modeHint: "L'accès distant donne aux clients itinérants une adresse dans le tunnel ; le site to site réunit deux réseaux",
        port: "Port d'écoute",
        protocol: 'Transport',
        protocolWireguardHint: 'WireGuard ne parle que UDP',
        tunnelSubnet: 'Subnet du tunnel',
        tunnelSubnetHint: 'Le réseau où vivent les clients — enregistré dans le registre IPAM, il naît et meurt avec ce service',
        dnsServers: 'DNS poussés aux clients',
        routes: 'Routes poussées aux clients',
        routesHint: 'Réseaux séparés par des virgules joignables par le tunnel ; la subnet du tunnel est toujours incluse',
        peers: 'Peers',
        peersHint: 'Laissez la clé publique vide et TVirt génère la paire — il la remet ensuite avec le profil. Collez une clé et le peer garde la sienne.',
        clients: 'Clients',
        clientsHint: "Chaque client reçoit un certificat émis par la CA propre à ce service. Retirer un client le RÉVOQUE : la CRL est régénérée aussitôt.",
        peerName: 'Nom',
        publicKey: 'Clé publique',
        publicKeyMinted: 'TVirt la génère',
        peerAddress: 'Adresse dans le tunnel',
        peerAddressHint: 'Vide = attribuée',
        allowedIps: 'Subnets distants',
        allowedIpsHint: 'Séparés par des virgules, routés par ce peer',
        endpoint: 'Endpoint',
        presharedKey: 'Clé pré-partagée',
        keepalive: 'Keepalive (s)',
        addPeer: 'Ajouter un peer',
        addClient: 'Ajouter un client',
        auth: 'Authentification',
        authTls: 'Certificats (TLS)',
        remote: 'Endpoint distant',
        remoteHint: "host:port du bout distant — vide signifie que ce côté attend",
        peerRoutes: 'Subnets distants',
        serverPublicKey: 'Clé publique de ce serveur',
        ca: 'Autorité de certification',
        listening: 'À l\'écoute sur',
        tunnel: 'Tunnel',
        peerCount: '{n} peers',
        download: 'Télécharger le profil',
        downloadError: "Le profil n'a pas pu être exporté",
        lastHandshake: 'Dernier handshake',
        never: 'jamais',
        traffic: '↓ {rx} · ↑ {tx}',
        connected: 'Connecté',
        idle: 'Inactif'
      },
      gateway: {
        attach: "Type de réseau d'écoute",
        attachOverlay: 'Réseau overlay',
        attachNetwork: 'Réseau logique de fabric',
        attachInterface: 'Interface brute',
        overlay: 'Réseau overlay',
        network: 'Réseau logique',
        interface: "Nom de l'interface",
        interfaceHint: "Une interface hôte que TVirt ne gère pas — l'adresse est prise pour argent comptant",
        address: "Adresse d'écoute (gateway)",
        addressHint: "L'adresse gateway vers laquelle pointent les clients — dans la subnet du réseau d'écoute",
        dnatTitle: 'Règles DNAT',
        dnatHint: 'NAT de destination : le trafic du match est redirigé vers une nouvelle adresse (et éventuellement un nouveau port). Tout protocole de la liste — les ports là où le protocole les porte.',
        snatTitle: 'Règles SNAT',
        snatHint: "NAT de source : le trafic du match sort avec la source réécrite — une nouvelle adresse explicite (et éventuellement un nouveau port), ou masquerade sur l'adresse de sortie si laissée vide.",
        oneToOneTitle: 'Règles 1:1 NAT',
        oneToOneHint: "Chaque paquet vers l'adresse externe est mappé sur l'interne, et l'hôte interne sort comme l'externe — tous les protocoles, dans les deux sens.",
        external: 'Adresse externe',
        internal: 'Adresse interne',
        addOneToOne: 'Ajouter une règle 1:1',
        family: 'Famille',
        protocol: 'Protocole',
        source: 'Source (adresse/subnet)',
        destination: 'Destination (adresse/subnet)',
        invert: 'NOT',
        srcPorts: 'Ports source',
        dstPorts: 'Ports dest.',
        dstPortsHint: 'Port ou plage (80, 8000-8099)',
        toAddress: 'Nouvelle adresse',
        toPort: 'Nouveau port',
        snatTo: 'Nouvelle source (vide = masquerade)',
        snatToHint: "Adresse source explicite ; vide = masquerade sur l'adresse de sortie",
        addDnat: 'Ajouter une règle DNAT',
        addSnat: 'Ajouter une règle SNAT',
        routesTitle: 'Routes statiques',
        routesHint: "Le nœud route entre les réseaux auxquels il est attaché (l'IP forwarding est actif) ; ces routes ajoutent de la joignabilité au-delà — noyau pur, le routage dynamique arrive avec un round ultérieur.",
        routeDestination: 'Subnet de destination',
        routeGateway: 'Next hop',
        routeMetric: 'Métrique',
        addRoute: 'Ajouter une route',
        listening: 'À l\'écoute sur',
        rules: '{d} DNAT · {o} 1:1 · {s} SNAT · {r} routes'
      },
      unknownSince: 'Inconnu — dernier rapport il y a {m} min',
      lastWord: 'Dernier mot',
      reportObservedAt: 'Dernier rapport',
      lastErrorRow: 'Dernière erreur',
      recordsCount: '{n} records manuels',
      phase: {
        configured: 'Configuré',
        running: 'En exécution',
        error: 'Erreur'
      },
      authorityNode: 'Authority (attribution)',
      preferredNode: 'Nœud préféré',
      preferredNodeHint: 'Une préférence douce, jamais une contrainte : à la prochaine décision de placement, l\'instance atterrit ici si le membre est éligible — à elle seule, elle ne déplace rien ; le mouvement, c\'est « Transférer l\'authority ».',
      noPreference: 'Aucune préférence (placement automatique)',
      moving: 'En mouvement',
      movingTooltip: 'Observé ici pendant que l\'authority assigne {node} : le mouvement converge.',
      placement: {
        title: 'Placement',
        loading: 'Recensement en cours…',
        loadError: 'Le recensement de placement n\'a pas répondu — réessayez plus tard.',
        draftHint: 'Le recensement se calcule sur le rattachement réseau déclaré : il apparaîtra une fois le service créé. La création est refusée si aucun membre ne peut le servir, et le refus nomme le mécanisme qui a vidé l\'ensemble.',
        eligibleCount: '{n} membres sur {m} peuvent servir cette instance',
        recommended: 'Recommandé',
        eligible: 'Éligible',
        notEligible: 'Non éligible',
        blockedReachability: 'le réseau n\'arrive pas sur ce membre',
        blockedRequireTag: 'bloqué par un tag obligatoire (requireNodes)',
        blockedExcluded: 'exclu par la simulation',
        preferenceUnknown: 'n\'est pas (ou plus) un membre du cluster',
        preferenceIgnored: 'La préférence « {node} » n\'est pas éligible aujourd\'hui : {reason}. La recommandation du recensement l\'emporte — jamais une erreur, le service vit ailleurs.',
        emptyReachability: 'Aucun membre ne peut servir cette instance : le réseau n\'arrive nulle part — aucune retouche des tags n\'y aidera. Câblez le nœud, ou déplacez le service là où le réseau est présent.',
        emptyRequireTag: 'Aucun membre ne peut servir cette instance : ce sont les tags obligatoires qui ont vidé l\'ensemble — retirez l\'entrée de requireNodes, ou taguez un membre.',
        spof: 'Point de défaillance unique',
        spofDetail: 'Un seul membre peut héberger l\'instance : en cas de panne, le failover n\'a nulle part où aller. Un service multi-listener se déplace comme une UNITÉ — le candidat doit voir TOUS ses réseaux : c\'est le prix.',
        whatIf: 'Simuler des membres absents',
        whatIfHint: 'Le what-if du drain : demandez AVANT l\'évacuation, ne le découvrez pas au failover.',
        survives: 'Avec {nodes} absent(s), le service a encore un toit.',
        notSurvives: 'Évacuer {nodes} laisse ce service À TERRE : la contrainte dérivée l\'emporte sur la disponibilité (R30) — un démon vivant là où le réseau n\'arrive pas ne sert personne et n\'alarme personne.',
        transfer: 'Transférer l\'authority',
        transferError: 'Le transfert a échoué',
        transferTarget: 'Membre de destination',
        transferHint: 'Seuls les membres éligibles sont proposés — une préférence dans l\'ensemble valide, jamais un override. Aucune task : la prochaine passe des workers EST le mouvement (l\'ancien nœud fauche, le nouveau fait surgir).'
      }
    },
    fabric: {
      tabDerivation: 'Dérivation',
      importNetwork: 'Importer depuis une autre fabric',
      importTitle: 'Importer un réseau logique',
      importHint: 'L\'import est l\'adhésion explicite : le réseau reste au titulaire (même identité, même stem, même bridge tvf-<stem>) et d\'ici il se mappe sur les ports/LAGG de cette fabric — mapper, C\'EST affirmer que la livraison débouche dans le même domaine L2 que celle du titulaire.',
      importPick: 'Réseau du titulaire',
      importNone: 'Rien à importer : les autres fabrics n\'ont aucun réseau propre que cette fabric ne connaisse déjà',
      importedNetworksTitle: 'Réseaux importés',
      noImported: 'Aucun réseau importé',
      importedFrom: 'importé de {fabric}',
      importedBy: 'Importé par : {list}',
      importedCount: '+{n} importés',
      owner: 'Titulaire',
      bridge: 'Bridge',
      bond: 'Bond',
      unimport: 'Retirer l\'import',
      unimportConfirm: 'Retirer l\'import du réseau {name} (titulaire {fabric}) de cette fabric ? Refusé tant qu\'un port ou un LAGG de cette fabric le mappe, ou qu\'un invité, une App ou un service n\'est servi que par cette patte.',
      unimportRefused: 'Import encore utilisé — {detail}',
      deriv: {
        codeHint: {
          deviceHeldByFabric: 'Ce nœud prend déjà ce réseau d\'une autre fabric dont il est membre : un nœud prend un réseau partagé par UNE seule de ses pattes (deux uplinks du même L2 dans un bridge sans STP forment une boucle). Démappe-le sur les ports ou le LAGG de l\'une des deux fabrics.',
          otherFabricDerived: 'Le document porte le bloc d\'une fabric vers laquelle le nœud ne déclare plus aucun câble : applique d\'abord le plan de cette fabric (il propose le retrait de ses devices), ou prends-en possession avec take-ownership si la fabric n\'existe plus.'
        },
        hint: 'Le plan de dérivation O.3 : pour chaque nœud câblé, l\'état, le diff dérivé-vs-courant, la topologie de bond DÉCLARÉE, les flips dual-stack et les refus/avertissements structurés. Lecture seule jusqu\'à l\'apply EXPLICITE — rien n\'atterrit jamais tout seul sur un nœud.',
        refresh: 'Recharger le plan',
        empty: 'Aucun nœud n\'est câblé à cette fabric (et aucun n\'en porte encore le bloc).',
        refusal: 'Refus',
        warning: 'Avertissement',
        generation: 'génération du document {n}',
        state: {
          manual: 'Manuel',
          derived: 'Dérivé',
          diverged: 'Divergent'
        },
        topologyTitle: 'Topologie déclarée',
        members: 'membres',
        primary: 'primaire',
        held: 'tenu à UN seul membre',
        form: {
          perNetworkBond: 'Bond par réseau',
          singleBond: 'Bond unique de repli',
          laggBond: 'Bond LACP (LAGG)',
          singlePort: 'Port unique'
        },
        colAction: 'Action',
        colKind: 'Type',
        colDevice: 'Device',
        colDetail: 'Détail',
        action: {
          add: 'ajouter',
          remove: 'retirer',
          replace: 'remplacer'
        },
        diffEmpty: 'Aucun diff en attente — le document appliqué coïncide avec le rendu.',
        diffBlocked: 'Aucun diff : les refus ci-dessus bloquent ce nœud.',
        phasePlanned: 'planifié (étape 1 sur 3)',
        phaseDraining: 'en drainage (étape 2 sur 3)',
        probeUnobserved: 'Sonde de drainage : jamais rapportée — le vide est INCONNU (un retrait serait refusé maintenant).',
        probeFailed: 'Sonde de drainage : observation ÉCHOUÉE — les horodatages connus sont conservés, jamais un « vide » que personne n\'a mesuré.',
        probeActive: {
          one: 'Sonde : {n} connexion établie encore sur l\'ancienne adresse',
          many: 'Sonde : {n} connexions établies encore sur l\'ancienne adresse',
          other: 'Sonde : {n} connexions établies encore sur l\'ancienne adresse'
        },
        probeLastActive: 'dernière activité {time}',
        probeEmpty: {
          one: 'Sonde : vide depuis {n} minute',
          many: 'Sonde : vide depuis {n} minutes',
          other: 'Sonde : vide depuis {n} minutes'
        },
        probeEmptyUnknown: 'Sonde : vide (depuis quand, inconnu).',
        impact: '{nics} vNIC et {apps} App sur ce nœud utilisent ces réseaux : {list}',
        apply: 'Appliquer sur ce nœud',
        applyTitle: 'Appliquer la dérivation — {node}',
        applyIntro: 'La configuration dérivée réécrit le document réseau de {node} ({n} changements) par la même porte que l\'éditeur host-network — checkpoint NetworkManager et probe honnête compris. Les avertissements du plan ci-dessous voyagent avec l\'acte : lisez-les avant de confirmer.',
        applyError: 'Apply échoué',
        applyRefused: 'Le nœud a refusé :',
        planMoved: 'La fabric a changé après cet aperçu — RIEN n\'a été appliqué. Le plan a été rechargé : regardez à nouveau et réessayez.',
        retire: 'Retirer',
        retireTitle: 'Point de non-retour — retrait de {address}',
        restore: 'Restaurer',
        restoreTip: 'Retour à l\'instantané d\'avant l\'apply (génération {previous}) — l\'annulation en un pas (H13)',
        restoreTitle: 'Restaurer le document précédent — {node}',
        restoreIntro: 'Le document réseau de {node} revient à l\'instantané pris avant le dernier apply (génération {previous}), réécrit en génération {next} à la place de la {current}. Le worker le fait converger comme tout autre document.',
        restoreRedo: 'Le document remplacé devient le nouvel instantané : restaurer à nouveau est le redo.',
        restoreClosesChain: 'L\'instantané est le document manuel d\'avant la dérivation : la chaîne se ferme ici — plus d\'annulation, le nœud reste manuel jusqu\'au prochain apply.',
        restoreConfirm: 'Restaurer',
        restoreError: 'Restauration échouée',
        retireIntro: 'Ceci retire {address} ({network}) de {point} définitivement. Après cet acte, le chemin du retour est le flip INVERSE — redéclarer l\'ancienne adresse via le même moteur — jamais une restauration aveugle.',
        retireOld: 'Ancienne adresse (retirée)',
        retireNew: 'Nouvelle adresse (reste)',
        retireEmptyFact: 'La sonde donne l\'adresse vide : ce retrait ne coupe aucune connexion observée.',
        retireConfirm: 'Retirer l\'adresse',
        severActiveLoss: {
          one: 'Couper {n} connexion établie encore sur l\'ancienne adresse — elle meurt avec cet acte',
          many: 'Couper {n} connexions établies encore sur l\'ancienne adresse — elles meurent avec cet acte',
          other: 'Couper {n} connexions établies encore sur l\'ancienne adresse — elles meurent avec cet acte'
        },
        severUnknownLoss: 'Accepter l\'INCONNU : la sonde n\'a jamais observé cette adresse (ou l\'observation échoue) — des connexions vivantes peuvent être coupées.'
      },
      title: 'Fabric',
      createTitle: 'Créer une fabric',
      networks: 'Réseaux',
      switches: 'Switchs',
      ports: 'Ports',
      laggs: 'LAGG',
      subnets: 'Subnets',
      tabOverview: "Vue d'ensemble",
      tabNetworks: 'Réseaux logiques',
      tabSwitches: 'Switchs',
      overviewHint: "La fabric en un coup d'œil : chaque réseau logique avec MTU et subnet (les VLAN ne vivent que dans les mappages par port/par LAGG — le même réseau peut voyager avec des tags différents sur des ports différents). La fabric est le registre d'une infrastructure EXTERNE — TVirt observe et déclare, ne fait jamais de provisioning, et ne touche que les NIC enregistrées sous son contrôle.",
      absorptionHint: 'Chaque subnet déclaré ici DÉRIVE son entrée dans le registre IPAM dans la même écriture — il vit et meurt avec le réseau.',
      scopeFixedHint: 'Le scope est fixé à la racine du cluster : l\'infrastructure physique est par définition à l\'échelle du cluster.',
      networksHint: 'Chaque réseau porte un MTU obligatoire (défaut 1500) et un subnet obligatoire ; gateway, serveurs DNS et routes statiques déclarés ici sont la SOURCE UNIQUE pour les NIC des serveurs, les Apps et les services réseau.',
      switchesHint: "Le registre manuel : un port est inutilisé, mappé (trafic untagged et par tag VLAN vers les réseaux logiques) ou membre d'un LAGG — un membre ne porte aucun mappage propre.",
      mtu: 'MTU',
      cidr: 'CIDR',
      cidrHint: "Obligatoire — l'IPAM en dérive automatiquement l'entrée de registre",
      nodeAddressing: 'Adressage des nœuds',
      nodeAddressingNone: 'Aucun — pas d\'adresse par nœud',
      nodeAddressingPool: 'Pool — une adresse fixe par nœud desservi',
      nodeAddressingHint: 'Avec Pool, la dérivation du fabric attribue à chaque nœud desservi une adresse issue des plages réservées à TVirt (fixe une fois attribuée).',
      backing: 'Backing',
      gateway: 'Gateway',
      ranges: 'Ranges réservés',
      dns: 'Serveurs DNS (séparés par des virgules)',
      dnsShort: 'DNS',
      singleSourceHint: 'Gateway, DNS et routes déclarés ici sont la source unique — les NIC des serveurs, les Apps et les services réseau puisent ici',
      routesTitle: 'Routes statiques',
      routeDestination: 'Destination (CIDR)',
      routeVia: 'Via (next hop)',
      portUsed: 'Utilisé',
      vlanMappings: 'Mappings VLAN',
      vlanTag: 'Tag VLAN',
      vlanNetwork: 'Réseau logique',
      nameTaken: 'Nom déjà utilisé dans la fabric',
      addNetwork: 'Ajouter un réseau',
      editNetwork: 'Modifier le réseau',
      deleteNetwork: 'Retirer le réseau',
      deleteNetworkConfirm: "Retirer le réseau logique {name} de la fabric ? Son subnet dérivé dans l'IPAM meurt avec lui (refusé tant qu'un service ou une App l'utilise). Les mappages de ports et de LAGG qui la référencent sont nettoyés.",
      switchName: 'Switch',
      portName: 'Port',
      positionHint: 'Position physique (optionnelle) — le même vocabulaire que le placement des serveurs ; déclarative seulement',
      addSwitch: 'Ajouter un switch',
      editSwitch: 'Modifier le switch',
      deleteSwitch: 'Retirer le switch',
      deleteSwitchConfirm: 'Retirer le switch {name} avec tous ses ports ? Les LAGG rétrécissent en conséquence (et meurent sous deux ports).',
      addPort: 'Ajouter un port',
      editPort: 'Modifier le port',
      deletePort: 'Retirer le port',
      deletePortConfirm: 'Retirer le port {name} ?',
      untagged: 'Untagged',
      tagged: 'Tagged (tag:réseau)',
      taggedShort: 'Tagged',
      portCabling: 'Câblage',
      portState: 'État',
      stateUnused: 'inutilisé',
      stateMapped: 'mappé',
      laggPortGuard: "Un port membre d'un LAGG se modifie du côté LAGG",
      laggsTitle: 'LAGG',
      laggsHint: 'Un LAGG est 2+ ports en LACP et peut traverser les switchs (MLAG, transparent) ; seuls les ports inutilisés y entrent, le LAGG est la surface de mappage, un port retiré redevient inutilisé.',
      addLagg: 'Ajouter un LAGG',
      editLagg: 'Modifier le LAGG',
      deleteLagg: 'Retirer le LAGG',
      deleteLaggConfirm: 'Retirer le LAGG {name} ? Ses ports membres redeviennent inutilisés.',
      lacpRate: 'Rate LACP',
      laggPorts: 'Ports membres (2+)',
      laggPortsHint: "Seuls les ports inutilisés entrent — libérez d'abord un port mappé",
      noNetworks: 'Aucun réseau logique déclaré.',
      noSwitches: 'Aucun switch déclaré.',
      noLaggs: 'Aucun LAGG déclaré.',
      staleConflict: "Un autre opérateur a modifié cette fabric pendant que vous la modifiiez : l'enregistrement a été refusé pour ne pas effacer son travail. Vos modifications sont toujours là, intactes. La fabric à jour a déjà été rechargée : confirmez de nouveau pour les réappliquer par-dessus, ou annulez et regardez ce qui a changé."
    },
    ipam: {
      title: 'IPAM',
      derivedHint: "Dérivé seulement : chaque subnet naît d'un réseau logique de fabric ou d'un overlay — il se modifie à la source. Les adresses assignées montrent QUI les tient ; les ranges réservés à TVirt sont les pools de l'assignation automatique.",
      search: 'Rechercher par nom, CIDR ou adresse',
      empty: "Aucun réseau — déclarez un réseau logique de fabric ou un subnet overlay : l'IPAM dérive d'eux automatiquement.",
      reserved: 'Ranges réservés à TVirt',
      address: 'Adresse',
      origin: 'Provenance',
      origin_declared: 'déclarée',
      origin_observed: 'observée',
      holder: 'Tenue par',
      noAddresses: 'Aucune adresse connue dans ce subnet.',
      sourceFabric: 'Fabric',
      sourceOverlay: 'Overlay',
      editAtSource: 'Modifier à la source'
    },
    firewall: {
      title: 'Groupes de pare-feu',
      createTitle: 'Nouveau groupe de pare-feu',
      editTitle: 'Modifier le groupe de pare-feu',
      empty: "Aucun groupe de pare-feu — créez-en un : un vocabulaire de règles réutilisable, que les NIC d'invité référencent par son nom.",
      nameHint: 'Lettres, chiffres et . - _ intérieurs ; unique dans son scope (les homonymes ailleurs se distinguent par /scope/nom)',
      description: 'Description',
      descriptionHint: "Une ligne d'intention, montrée partout où le groupe se choisit",
      enforced: 'Imposé au scope',
      enforcedHint: "Éteint : vocabulaire pur — les règles ne lient que les NIC qui référencent le groupe. Allumé : les règles lient chaque NIC d'invité au pare-feu allumé sous le scope du groupe, référencées ou non.",
      enforcedChip: 'Imposé',
      enforcedChipHint: "Les règles lient chaque NIC d'invité au pare-feu allumé sous le scope du groupe, référencées ou non",
      enforceWarning: "En activant l'imposition, les règles lient CHAQUE NIC d'invité au pare-feu allumé sous {scope} au prochain alignement, même sans référence explicite — et dans une chain active le drop d'un ancêtre est définitif : les niveaux en dessous ne le rouvrent pas.",
      unenforceInfo: "En retirant l'imposition, les règles ne restent que sur les NIC qui référencent le groupe explicitement.",
      rules: 'Règles',
      tabOverview: "Vue d'ensemble",
      tabRules: 'Règles',
      orderHint: "L'ordre des lignes EST l'ordre d'évaluation dans le groupe : la première règle qui correspond gagne.",
      statefulHint: "Le stateful est implicite : les réponses au trafic admis passent d'elles-mêmes (established/related acceptées, invalid écarté — c'est le moteur qui les injecte, elles ne s'écrivent pas à la main).",
      noRules: 'Aucune règle — un vocabulaire en construction : le référencer est licite et ne rend rien.',
      addRule: 'Ajouter une règle',
      direction: 'Direction',
      directionIn: 'Entrant',
      directionOut: 'Sortant',
      action: 'Action',
      action_accept: 'Accepter',
      action_drop: 'Écarter',
      action_reject: 'Rejeter',
      protocol: 'Protocole',
      protocolAny: 'Tous',
      ports: 'Ports',
      source: 'Source',
      dest: 'Destination',
      comment: 'Commentaire',
      addressHint: 'CIDR IPv4 ou <fabric>/<réseau logique> ; vide = tout',
      moveUp: 'Monter',
      moveDown: 'Descendre',
      nicFirewall: 'Pare-feu',
      nicAntiSpoof: 'Anti-spoofing',
      nicGroups: 'Groupes de pare-feu',
      nicGroupsPlaceholder: 'Choisissez un groupe…',
      nicGroupsHint: 'Les groupes visibles, y compris ceux des scopes supérieurs (utilisables vers le bas, comme les tags)',
      nicGroupCount: { one: '{n} groupe de pare-feu', many: '{n} groupes de pare-feu', other: '{n} groupes de pare-feu' },
      nicOff: 'Pare-feu éteint',
      pendingRestartHint: "Les modifications du pare-feu suivent le modèle enregistré/appliqué : elles attendent le prochain power cycle (PendingRestart). Les groupes imposés par les scopes supérieurs s'appliquent quand le pare-feu de la NIC est allumé.",
      appConvergeHint: "Les modifications du pare-feu s'appliquent au prochain alignement du container. Les groupes imposés par les scopes supérieurs s'appliquent quand le pare-feu est allumé.",
      enforcedAncestors: 'Imposés par les scopes supérieurs',
      enforcedAncestorsHint: "Ce groupe s'applique à chaque NIC sous son scope dont le pare-feu est ALLUMÉ — le toggle est l'interrupteur général de la NIC (éteint = aucune chain, ancêtres compris) ; dans une chain active l'autorité de l'ancêtre est définitive : son drop ne se rouvre pas en dessous."
    }
  }
}
